import {EventBus} from 'powtoon-commons/events'
import {PusherListener, PusherConfig} from 'powtoon-commons/pusher/PusherListener'
import webvarsConfigurationService from '../services/webvarsConfigurationService'
import {
  PowtoonContentVideoUrlUpdatedConverter,
  PowtoonRecordingVideoUpdatedConverter
} from 'powtoon-commons/pusher/EventConverters'
import {createLogger} from 'logging'

// @ts-ignore
import cookie from 'cookie'
import {IPowtoonEvent, PowtoonEventType} from 'powtoon-commons/events/types'

const logger = createLogger('powtoon-segments-player', 'event-service')

interface SubscriptionsEventHandler {
  event: PowtoonEventType,
  handler: (event: IPowtoonEvent) => void
}

export interface Unsubscribe {
  unsubscribeAll: () => void
}

export const defaultEventBus: EventBus = new EventBus(logger)

const eventConverters = [
  PowtoonContentVideoUrlUpdatedConverter,
  PowtoonRecordingVideoUpdatedConverter
]

export const initSegmentsPlayerEventBus = (): EventBus => {
  const config: PusherConfig = {
    pusherKey: webvarsConfigurationService.getWebVar('pusherKey'),
    userId: process.env.USER_ID || webvarsConfigurationService.getWebVar('userId'),
    sessionId: process.env.SESSION_ID || webvarsConfigurationService.getWebVar('sessionId'),
    csrfToken: process.env.CSRF_TOKEN || cookie.parse(document.cookie).csrftoken,
    apiHost: webvarsConfigurationService.getWebVar('apiHost'),
    cluster: webvarsConfigurationService.getWebVar('pusherRegion')
  }

  new PusherListener(config, eventConverters, defaultEventBus, logger)

  return defaultEventBus
}

export const subscriptionsEventBus = (subscriptionsHandler: SubscriptionsEventHandler[]): Unsubscribe => {

  const subscriptions = subscriptionsHandler.map(({event, handler}) => {
    const localHandler = (e: IPowtoonEvent) => {
      handler(e)
    }
    defaultEventBus.on(event, localHandler)
    return () => defaultEventBus.off(event, localHandler)
  })

  const unsubscribeAll = () => subscriptions.forEach(unsubscribe => unsubscribe())
  return ({unsubscribeAll})
}

export const subscriptionsByLoadDocument = (
  loadDocumentFunction: () => void,
  powtoonId?: string,
  onSubscriptions = subscriptionsEventBus
): Unsubscribe => {
  const handler = (event: IPowtoonEvent) => {
    if (powtoonId && (event as any)?.powtoonId === powtoonId) {
      loadDocumentFunction()
    }
  }
  return onSubscriptions([
    {event: PowtoonEventType.PowtoonRecordingVideoUrlUpdated, handler},
    {event: PowtoonEventType.PowtoonContentVideoUrlCreated, handler}
  ])
}
